//@flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import { below } from "../../assets/css/media";

const RoundItemWrapper = styled.div`
		flex: 0 0 auto;
		justify-content: center;
		display: flex;
		align-items: center;
		height: 100%;
		width: 70px;
		color: ${colors.round_selector_item};
		line-height: 1.35;
		margin: 0;
		cursor: pointer;
		font-size: 12px;
		&.selected{
			font-size: 14px;
			font-weight: bold;
			color:  ${colors.nrlDarkGreen};
			padding: 0;
		}

		&.complete{
			color: ${colors.toggle_background};
		}
		&.scheduled{
			color: ${colors.darkGrey};
		}

		${below.phone`
			min-width:19%;
		`}
		&.first{
			margin-left: ${({ index }) => 'calc(50% - '+ 35 * (2 * index + 1) + 'px)'};
		}
`;

type Props = {
	round_number?: number | null,
	round_status?: string | null,
	selected_round: number | null,
	selected_round_index: number | null,
	is_first: boolean,
	round_alias?: string | number,
	handleClick: Function
}

export const RoundSelectorItem = (
	{ selected_round, round_number, round_alias,
		round_status, handleClick, selected_round_index, is_first }: Props
) => {
	const active_class_name =
		selected_round === round_number ? 'selected' : round_status;
	const first_one_class = is_first ? 'first' : '';
	const class_name = active_class_name ? active_class_name + ' ' + first_one_class : '';
	return (
		<RoundItemWrapper
			key={round_number}
			className={class_name}
			onClick={() => handleClick(round_number)}
			selected_round={selected_round}
			index={selected_round_index}
		>
			{
				round_alias ||
				(round_number ? `Round  ${round_number}` : '-')
			}
		</RoundItemWrapper>
	);
};

RoundSelectorItem.defaultProps = {
	round_number: 1,
	selected_round: 1,
	round_status: 'active'
};
export default RoundSelectorItem;


// WEBPACK FOOTER //
// ./src/components/RoundSelector/RoundSelectorItem.js